module.exports = __webpack_public_path__ + "ed50336b3f5d0f6086a9b34d9036b4ef.svg";